import { CvTemplate } from "../../../setups/types/setupTypes";
import { GradientTemplate, LabelTemplate } from "../styles/table";

const DEFAULT_GRADIENT: GradientTemplate = {
  typeOfGradient: "linear-gradient",
  degree: "90deg",
  firstColor: "transparent",
  firstPercentage: "0%",
  secondColor: "transparent",
  secondPercentage: "100%",
};

export function parseGradientString(
  encoded?: string | null,
): GradientTemplate {
  if (!encoded) return DEFAULT_GRADIENT;
  const parts = encoded.split("_");
  if (parts.length !== 6) return DEFAULT_GRADIENT;
  return {
    typeOfGradient: parts[0],
    degree: parts[1],
    firstColor: parts[2],
    firstPercentage: parts[3],
    secondColor: parts[4],
    secondPercentage: parts[5],
  };
}

export function cvTemplateToLabel(cv: CvTemplate): LabelTemplate {
  return {
    name: cv.name,
    numberOfPages: cv.numberOfPages,
    cvLang: cv.cvLang,
    bgColor: cv.bgColor,
    headFontColor: cv.headFontColor,
    headBgColor: cv.headBgColor,
    labelFontColor: cv.labelFontColor,
    labelBgColor: cv.labelBgColor,
    valueFontColor: cv.valueFontColor,
    valueBgColor: cv.valueBgColor,
    borderColor: cv.borderColor,
    borderRadius: cv.borderRadius,
    borderWidth: cv.borderWidth,
    borderStyle: cv.borderStyle,
    spacing: cv.spacing,
    labelFontSize: cv.labelFontSize,
    valueFontSize: cv.valueFontSize,
    labelFontWeight: cv.labelFontWeight,
    valueFontWeight: cv.valueFontWeight,
    textTransform: cv.textTransform,
    headerHeight: cv.headerHeight,
    bodyHeight: cv.bodyHeight,
    headerGradient: parseGradientString(cv.headerGradient),
    evenGradient: parseGradientString(cv.evenGradient),
    oddGradient: parseGradientString(cv.oddGradient),
    addPassportHeader: cv.addPassportHeader,
    useHeaderGradient: cv.useHeaderGradient,
    useBodyGradient: cv.useBodyGradient,
    headerShadow: cv.headerShadow,
    bodyShadow: cv.bodyShadow,
    photoShadow: cv.photoShadow,
    passportShadow: cv.passportShadow,
    qrLocationLink: cv.qrLocationLink,
    qrLocationWidth: cv.qrLocationWidth,
    qrLocationHeight: cv.qrLocationHeight,
    qrLocationImageUrl: cv.qrLocationImageUrl,
    qrLocationMargin: cv.qrLocationMargin,
    qrMoreCvsLink: cv.qrMoreCvsLink,
    qrMoreCvsWidth: cv.qrMoreCvsWidth,
    qrMoreCvsHeight: cv.qrMoreCvsHeight,
    qrMoreCvsImageUrl: cv.qrMoreCvsImageUrl,
    qrMoreCvsMargin: cv.qrMoreCvsMargin,
    faceHeight: cv.faceHeight,
    faceWidth: cv.faceWidth,
    standHeight: cv.standHeight,
    standWidth: cv.standWidth,
    flagHeight: cv.flagHeight,
    flagWidth: cv.flagWidth,
    passportHeight: cv.passportHeight,
    passportWidth: cv.passportWidth,
    headBgColorAlpha: cv.headBgColorAlpha,
    headGrFirstColorAlpha: cv.headGrFirstColorAlpha,
    headGrSecondColorAlpha: cv.headGrSecondColorAlpha,
    labelBgColorAlpha: cv.labelBgColorAlpha,
    oddGrFirstColorAlpha: cv.oddGrFirstColorAlpha,
    oddGrSecondColorAlpha: cv.oddGrSecondColorAlpha,
    valueBgColorAlpha: cv.valueBgColorAlpha,
    evenGrFirstColorAlpha: cv.evenGrFirstColorAlpha,
    evenGrSecondColorAlpha: cv.evenGrSecondColorAlpha,
  };
}
